export default {
  currency: "£",
};
